var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_FILL0_wght400_GRAD0_opsz48",
    d: "M24.778,25.95l-7.306-7.306a6.121,6.121,0,0,1-1.944,1.125,6.875,6.875,0,0,1-2.361.4,6.916,6.916,0,0,1-5.083-2.083A6.851,6.851,0,0,1,6,13.061,6.851,6.851,0,0,1,8.083,8.033,6.884,6.884,0,0,1,13.139,5.95a6.806,6.806,0,0,1,5.014,2.083,7.109,7.109,0,0,1,1.681,7.333,7.051,7.051,0,0,1-1.167,2.083L26,24.728ZM13.139,18.506a5.2,5.2,0,0,0,3.833-1.6,5.267,5.267,0,0,0,1.583-3.847,5.267,5.267,0,0,0-1.583-3.847,5.2,5.2,0,0,0-3.833-1.6,5.276,5.276,0,0,0-3.875,1.6,5.244,5.244,0,0,0-1.6,3.847,5.244,5.244,0,0,0,1.6,3.847,5.276,5.276,0,0,0,3.875,1.6Z",
    transform: "translate(-6 -5.95)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.1161ecf8f96f81e6b94585c62457a8b0.svg";
export { ForwardRef as ReactComponent };